import type { TelemetryInstruction } from '@modules/prism/versions/2025-07-01/utils/telemetry/types.api';

/**
 * Converts form telemetry instructions to form name attribute for tracking
 *
 * Returns the form name attribute to be spread onto the HTML form element.
 * This enables @tuic/tracking's TrackFormAttribution component to automatically track:
 * - Form submission events
 * - Field interaction events (focus + change)
 *
 * @param telemetry - Array of telemetry instructions from the API
 * @returns Object with name attribute, or empty object if no form telemetry
 *
 * @example
 * ```tsx
 * <form {...telemetryToFormAttributes(form.telemetry)} onSubmit={handleSubmit}>
 *   <input name="email" />
 *   <button type="submit">Submit</button>
 * </form>
 * ```
 *
 * Output:
 * ```html
 * <form name="newsletter-signup">
 * ```
 */
export function telemetryToFormAttributes(
  telemetry: TelemetryInstruction[] | undefined,
): { name?: string } {
  // New approach: 'form' type instruction
  const formInstruction = telemetry?.findLast(t => t.type === 'form');

  if (formInstruction && formInstruction.type === 'form') {
    return { name: formInstruction.formName };
  }

  return {};
}
